import { graphql } from '../graphql';

export const savedViewsQuery = graphql(`
  query SavedViews($projectId: ID!) {
    savedViews(projectId: $projectId) {
      id
      projectId
      name
      description
      visibility
      camera
      clipBox
      visibleLayerIds
      baseMapId
      isInitial
      createdById
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
    }
  }
`);
